import { useEffect, useRef, useCallback, useMemo } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../config';

const API = `${BACKEND_URL}/api`;

const MonitoreoActivo = ({ userId, userRole, onInactivo }) => {
  const actividadIntervalRef = useRef(null);
  const ultimaActividadRef = useRef(null);

  const TIEMPO_INACTIVIDAD = useMemo(() => 10 * 60 * 1000, []); // 10 minutos

  const debeMonitorear = userRole === 'chatter' || userRole === 'asistente';

  useEffect(() => {
    ultimaActividadRef.current = Date.now();
  }, []);

  const registrarActividad = useCallback(() => {
    ultimaActividadRef.current = Date.now();
  }, []);

  const desconectarUsuario = useCallback(async () => {
    try {
      await axios.post(`${API}/monitoreo/desconexion`, {
        user_id: userId,
        razon: 'inactividad_10_minutos',
        timestamp: new Date().toISOString()
      }, { withCredentials: true });

      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });

      if (onInactivo) onInactivo();

      window.location.href = '/';
    } catch (e) {
      window.location.href = '/';
    }
  }, [userId, onInactivo]);

  useEffect(() => {
    if (!debeMonitorear) return;

    const eventos = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    eventos.forEach(ev => window.addEventListener(ev, registrarActividad));

    actividadIntervalRef.current = setInterval(() => {
      if (!ultimaActividadRef.current) {
        ultimaActividadRef.current = Date.now();
        return;
      }
      
      const tiempoInactivo = Date.now() - ultimaActividadRef.current;

      if (tiempoInactivo >= TIEMPO_INACTIVIDAD) {
        alert('Tu sesión ha expirado por inactividad.');
        desconectarUsuario();
      }
    }, 1000);

    return () => {
      eventos.forEach(ev => window.removeEventListener(ev, registrarActividad));
      if (actividadIntervalRef.current) clearInterval(actividadIntervalRef.current);
    };
  }, [debeMonitorear, registrarActividad, desconectarUsuario, TIEMPO_INACTIVIDAD]);

  return null;
};

export default MonitoreoActivo;
